var t;!function(t){t.TOP="top",t.BOTTOM="bottom",t.CENTER="center"}(t||(t={}));export{t as MenuTitleCaptionPosition};
